module.exports = __webpack_public_path__ + "img/base-para-bingo-silabas-directas.21ae1bb3.png";